import React from "react";
import {BrowserRouter} from "react-router-dom";
import "./App.scss";
import "./contexts/LoadingContext.scss";
import Main from "./containers/Main";
import ErrorBoundary from "@app/ErrorBoundary";
import {AuthProvider} from "./contexts/AuthContext";
import {SettingsProvider} from "./contexts/SettingsContext";
import {PortfolioProvider} from "./contexts/PortfolioContext";
import {LoadingProvider} from "./contexts/LoadingContext";

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <LoadingProvider>
          <AuthProvider>
            <SettingsProvider>
              <PortfolioProvider>
                <div>
                  <Main />
                </div>
              </PortfolioProvider>
            </SettingsProvider>
          </AuthProvider>
        </LoadingProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
